import React, { Component , Suspense } from "react";
import { Route , Switch } from "react-router-dom"

//components
import Home from "./Home/Home";

//classes
import classes from "./App.css";
import Loading from "./Assets/Loading/Loading";


// lazyLoading
const TZFE = React.lazy(()=>{
  return import ('./TwoZeroFourEight/TZFE');
})
const TicTacToe = React.lazy(()=>{
  return import ('./TicTacToe/TicTacToe');
})
const Snake = React.lazy(()=>{
  return import ('./Snake/Snake');
})
const DAB = React.lazy(()=>{
  return import ('./DotsAndBoxes/DAB');
})
const UTicTacToe = React.lazy(()=>{
  return import ("./UTicTacToe/UTicTacToe");
})
const Sim = React.lazy(()=>{
  return import ("./SIM/Sim");
})

const Leaderboard = React.lazy(()=>{
  return import ('./Leaderboard/Leaderboard');
})
const About = React.lazy(()=>{
  return import ('./Extras/About/About');
})
const Support = React.lazy(()=>{
  return import ('./Extras/Support/Support');
})

class App extends Component {

  render() {
    let routes = (<Switch>
        <Route path='/PlaySnakeGame' component={Snake} />
        <Route path='/PlayTicTacToe' component={TicTacToe} />
        <Route path='/Play2048' component={TZFE} />
        <Route path='/PlayDots-and-boxes' component={DAB} />
        <Route path="/Leaderboard" component={Leaderboard} />
        <Route path="/About" component={About} />
        <Route path="/PlayUltimateTicTacToe" component={UTicTacToe} />
        <Route path="/PlaySim" component={Sim} />
        <Route path="/Support" component={Support} />
        <Route path="/" component={Home}/>  
    </Switch>)

    return (
      <div className={classes.App}>
        <Suspense fallback={<Loading />}>
          {routes}
        </Suspense>
      </div>
    );
  }
}

export default App;
